import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      // QRコード作成画面
      path: '/',
      name: 'createQrCode',
      component: () => import(/* webpackChunkName: "about" */ './views/CreateQrCode.vue'),
      meta: { isRoot: true },
    },
    {
      // QRコードダウンロード画面
      path: '/downloadQrCode',
      name: 'downloadQrCode',
      component: () => import(/* webpackChunkName: "about" */ './views/DownloadQrCode.vue'),
    },
  ],
});
export default router;
